export default {
  "content": "<g clip-path=\"url(#icon_shortcut_scan_receipt_svg__a)\"><path d=\"M28 .87v12.26c0 .56-.44 1-1 1s-1-.44-1-1v-10l-2 1-4-2-4 2-4-2-4 2-2-1v10c0 .56-.44 1-1 1s-1-.44-1-1V.87c0-.46.46-.74.86-.54L8 1.89 11.1.35c.56-.3 1.24-.3 1.8 0L16 1.89 19.1.35c.56-.3 1.24-.3 1.8 0L24 1.89 27.14.33c.4-.2.86.08.86.54zm0 20.26v10.26c0 .46-.46.74-.86.54L24 30.37l-3.1 1.54c-.56.3-1.24.3-1.8 0L16 30.37l-3.1 1.54c-.56.3-1.24.3-1.8 0L8 30.37l-3.14 1.56a.59.59 0 01-.86-.54V21.13c0-.56.44-1 1-1s1 .44 1 1v8l2-1 4 2 4-2 4 2 4-2 2 1v-8c0-.56.44-1 1-1s1 .44 1 1zm3-5H1a1 1 0 000 2h30a1 1 0 100-2z\"/></g><defs><clipPath id=\"icon_shortcut_scan_receipt_svg__a\"><path d=\"M32 .13H0v32h32z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "33",
    "fill": "currentColor",
    "viewBox": "0 0 32 33"
  }
};